import { render, staticRenderFns } from "./PaymentConnectionAlert.vue?vue&type=template&id=4436a9f8"
import script from "./PaymentConnectionAlert.vue?vue&type=script&lang=js"
export * from "./PaymentConnectionAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports